import React, { memo, useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import {
  getTicketForms,
  getTicketList,
  handleFilterArea,
} from "../../../store/managerTickets/actions";

import { showToast } from "../../../Libs/CustomMethods/showToast";

function Header({ number = "-" }) {
  const { t } = useTranslation();
  const data = useSelector((state) => state.ManagerTickets.tableData);

  return (
    <>
      <h4>{`${data?.length ?? 0} ${t("Tickets found")}`}</h4>
      <Buttons />
    </>
  );
}

export default memo(Header);

const Buttons = memo(() => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { mainTheme } = useSelector((state) => state.Layout);
  const { table, forms } = useSelector(
    (state) => state.ManagerTickets.status
  );

  useEffect(() => {
    if (table.error) {
      showToast(t(table.error), "error");
    }

    if (forms.error) {
      showToast(t(forms.error), "error");
    }
    
    if (table.message) {
      showToast(t(table.message), "info");
    }

  }, [table.error, forms.error, table.message, t]);

  const handleShowFilter = useCallback(() => {
    dispatch(handleFilterArea());
  }, [dispatch]);

  const handleRefresh = useCallback(() => {
    dispatch(getTicketList());
  }, [dispatch]);

  useEffect(() => {
    if (forms.loading || forms.success) return;

    if (forms.error) {
      setTimeout(() => {
        dispatch(getTicketForms());
      }, 5000);
    } else {
      dispatch(getTicketForms());
    }
  }, [forms, dispatch]);

  return (
    <div className="content-buttons">
      <button
        className={`${mainTheme === "dark" ? "dark" : "light bg-primary"} mx-2`}
        onClick={handleRefresh}
        disabled={table.loading}
      >
        <i
          className={`bx bx-refresh bx-xs mr-0 align-self-center header-button-icons header-button-refresh ${
            table.loading ? "loading-spinning" : ""
          }`}
        ></i>
      </button>
      <button
        className={`${mainTheme === "dark" ? "dark" : "light bg-primary"} mx-2`}
        onClick={handleShowFilter}
      >
        <i className="bx bx-filter bx-xs mr-0 align-self-center header-button-icons"></i>
      </button>
    </div>
  );
});
